import { Carousel, Container, Button, Row, Col } from "react-bootstrap";
import { BsChevronLeft, BsChevronRight, BsWrench, BsShieldCheck, BsClock, BsAward } from "react-icons/bs";


import "../Resources/style.css";

const Hero = () => {
  const slides = [
    {
      image:
        "https://images.unsplash.com/photo-1623220988124-bcd1bad9a408?crop=entropy&cs=srgb&fm=jpg&q=85",
      title: "Expertos en Mantenimiento de Motocicletas",
      subtitle: "Servicio profesional con más de 10 años de experiencia",
    },
    {
      image:
        "https://images.unsplash.com/photo-1623221013483-1f3cbeffdcec?crop=entropy&cs=srgb&fm=jpg&q=85",
      title: "Mantenimiento Preventivo y Correctivo",
      subtitle: "Tu motocicleta en las mejores manos",
    },
    {
      image:
        "https://images.unsplash.com/photo-1623220940666-f4bcc07aaed9?crop=entropy&cs=srgb&fm=jpg&q=85",
      title: "Tecnología y Experiencia",
      subtitle: "Herramientas modernas y conocimiento especializado",
    },
    {
      image: "https://images.pexels.com/photos/5184995/pexels-photo-5184995.jpeg",
      title: "Servicio de Calidad",
      subtitle: "Garantizamos la satisfacción de nuestros clientes",
    },
    {
      image: "https://images.pexels.com/photos/5184991/pexels-photo-5184991.jpeg",
      title: "Tu Taller de Confianza",
      subtitle: "YT MotoCenter - San José, Moravia",
    },
  ];

  const scrollToContact = () => {
    const element = document.getElementById("contact");
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero">
      {/* Carousel */}
      <Carousel fade interval={5000} prevIcon={<BsChevronLeft size={32} />} nextIcon={<BsChevronRight size={32} />}>
        {slides.map((slide, idx) => (
          <Carousel.Item key={idx}>
            <div
              style={{
                backgroundImage: `linear-gradient(rgba(0,0,0,0.55), rgba(0,0,0,0.55)), url(${slide.image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                height: "100vh",
              }}
            >

              <Container className="h-100 d-flex flex-column justify-content-center align-items-center text-center text-white">
                <img
                  src="https://customer-assets.emergentagent.com/job_biketechpro/artifacts/9yrxeouv_Image%20%2839%29.jpeg"
                  alt="YT MotoCenter Logo"
                  className="rounded-circle border border-4 border-light shadow mb-4"
                  style={{ width: "100px", height: "100px", objectFit: "cover" }}
                />
                <h1 className="display-4 fw-bold">{slide.title}</h1>
                <p className="lead mb-4 text-white fs-3">{slide.subtitle}</p>
                <div
                  className="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-3 fade-in-up"
                  style={{ animationDelay: "0.4s" }}
                >
                  <Button
                    variant="warning"
                    size="lg"
                    className="btn-primary px-4 py-3 fw-semibold"
                    onClick={scrollToContact}
                  >
                    <BsWrench size={20} className="me-2" />
                    Agendar Cita
                  </Button>

                  <Button
                    variant="outline-light"
                    size="lg"
                    className="btn-secondary px-4 py-3 fw-semibold"
                    onClick={() =>
                      document.getElementById("services")?.scrollIntoView({ behavior: "smooth" })
                    }
                  >
                    Ver Servicios
                  </Button>
                </div>

              </Container>
            </div>
          </Carousel.Item>
        ))}
      </Carousel>

      {/* Features Bar debajo del carousel */}
      <div className="py-2 barra-carrousel">
        <Container className="barra-carrousel">
          <Row className="text-center">
            <Col xs={6} md={3} className="d-flex align-items-center justify-content-center gap-2">
              <BsShieldCheck size={18} />
              <span className="fw-medium">Garantía de Servicio</span>
            </Col>
            <Col xs={6} md={3} className="d-flex align-items-center justify-content-center gap-2">
              <BsClock size={18} />
              <span className="fw-medium">Servicio Rápido</span>
            </Col>
            <Col xs={6} md={3} className="d-flex align-items-center justify-content-center gap-2">
              <BsAward size={18} />
              <span className="fw-medium">Técnicos Certificados</span>
            </Col>
            <Col xs={6} md={3} className="d-flex align-items-center justify-content-center gap-2">
              <BsWrench size={18} />
              <span className="fw-medium">Herramientas Modernas</span>
            </Col>
          </Row>
        </Container>
      </div>
    </section>


  );
};

export default Hero;
